/**
 * Generate the full URL for a team logo
 * @param logoPath - The logo path from the database (e.g. 'team-logos/filename.png' or '/uploads/team-logos/filename.png')
 * @returns The full URL to access the logo
 */
export const getTeamLogoUrl = (logoPath: string): string => {
  if (!logoPath) return '';
  
  // If logoPath is already a full URL, return it as is
  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath;
  }
  
  // Check if this is a legacy local path or a GCS path
  if (logoPath.startsWith('/uploads/') || logoPath.startsWith('uploads/')) {
    // Legacy local file path - fallback to API server (for backward compatibility)
    const serverBaseUrl = process.env.NODE_ENV === 'production' 
      ? 'https://api.pikfc.com' 
      : 'http://localhost:5001';
    
    const cleanLogoPath = logoPath.startsWith('/') ? logoPath : `/${logoPath}`;
    return `${serverBaseUrl}${cleanLogoPath}`;
  }
  
  // New GCS path format: 'team-logos/filename.png'
  // Construct Google Cloud Storage public URL
  // Use the correct bucket name: pikfc
  const bucketName = process.env.REACT_APP_GCS_BUCKET_NAME || 'pikfc';
  const cleanPath = logoPath.replace(/^\/+/, ''); // Remove leading slashes
  
  return `https://storage.googleapis.com/${bucketName}/${cleanPath}`;
}; 